var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReminder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reminder",
    transform: "translate(-354 -711)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_297",
    "data-name": "Ellipse 297",
    cx: 35,
    cy: 35,
    r: 35,
    transform: "translate(354 711)",
    fill: "#004b75",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-reminder-4303226",
    transform: "translate(362.246 715.717)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1264",
    "data-name": "Path 1264",
    d: "M12.459,20.121a3.71,3.71,0,0,0-3.705,3.711V44.159a3.712,3.712,0,0,0,3.705,3.714H30.267a.571.571,0,0,0,0-1.142H12.459A2.553,2.553,0,0,1,9.89,44.159v-16.3H42.455v3.128a.571.571,0,0,0,1.142,0V23.832a3.715,3.715,0,0,0-3.711-3.711H35.508a.57.57,0,1,0,0,1.138h4.379a2.551,2.551,0,0,1,2.568,2.572v2.883H9.89V23.831a2.552,2.552,0,0,1,2.569-2.572h4.38a.57.57,0,1,0,0-1.138h-4.38Z",
    transform: "translate(0 -3.09)",
    fill: "#135a7f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1265",
    "data-name": "Path 1265",
    d: "M39.578,14.421A1.113,1.113,0,0,1,40.7,15.549v3.828a1.124,1.124,0,0,1-2.249,0V15.549A1.111,1.111,0,0,1,39.578,14.421Zm-10.336,0a1.111,1.111,0,0,1,1.122,1.127v3.828a1.122,1.122,0,1,1-2.243,0V15.549A1.109,1.109,0,0,1,29.242,14.421Zm0-1.138a2.273,2.273,0,0,0-2.264,2.266v3.828a2.263,2.263,0,1,0,4.527,0V18.17h5.807v1.207a2.264,2.264,0,1,0,4.527,0V15.549a2.264,2.264,0,0,0-4.527,0v1.482H31.505V15.549A2.275,2.275,0,0,0,29.242,13.283Z",
    transform: "translate(-8.236 0)",
    fill: "#135a7f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1266",
    "data-name": "Path 1266",
    d: "M17.977,38.991h1.4a.8.8,0,0,1,.819.817v1.513a.805.805,0,0,1-.819.817h-1.4a.8.8,0,0,1-.816-.817V39.808A.8.8,0,0,1,17.977,38.991Zm0-1.142a1.964,1.964,0,0,0-1.953,1.959v1.513a1.964,1.964,0,0,0,1.953,1.958h1.4a1.966,1.966,0,0,0,1.956-1.958V39.808a1.967,1.967,0,0,0-1.956-1.959Z",
    transform: "translate(-3.285 -11.102)",
    fill: "#135a7f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1267",
    "data-name": "Path 1267",
    d: "M17.977,52.289h1.4a.806.806,0,0,1,.819.816v1.519a.8.8,0,0,1-.819.813h-1.4a.8.8,0,0,1-.816-.813V53.1A.805.805,0,0,1,17.977,52.289Zm0-1.137A1.959,1.959,0,0,0,16.024,53.1v1.519a1.959,1.959,0,0,0,1.953,1.953h1.4a1.962,1.962,0,0,0,1.956-1.953V53.1a1.961,1.961,0,0,0-1.956-1.953Z",
    transform: "translate(-3.285 -17.114)",
    fill: "#135a7f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1268",
    "data-name": "Path 1268",
    d: "M31.142,38.991h1.407a.8.8,0,0,1,.813.817v1.513a.8.8,0,0,1-.813.817H31.142a.8.8,0,0,1-.813-.817V39.808A.8.8,0,0,1,31.142,38.991Zm0-1.142a1.967,1.967,0,0,0-1.956,1.959v1.513a1.966,1.966,0,0,0,1.956,1.958h1.407A1.964,1.964,0,0,0,34.5,41.321V39.808a1.964,1.964,0,0,0-1.953-1.959Z",
    transform: "translate(-9.234 -11.102)",
    fill: "#135a7f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1269",
    "data-name": "Path 1269",
    d: "M31.142,52.289h1.407a.8.8,0,0,1,.813.816v1.519a.8.8,0,0,1-.813.813H31.142a.8.8,0,0,1-.813-.813V53.1A.8.8,0,0,1,31.142,52.289Zm0-1.137A1.961,1.961,0,0,0,29.186,53.1v1.519a1.961,1.961,0,0,0,1.956,1.953h1.407A1.959,1.959,0,0,0,34.5,54.624V53.1a1.959,1.959,0,0,0-1.953-1.953Z",
    transform: "translate(-9.234 -17.114)",
    fill: "#135a7f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1270",
    "data-name": "Path 1270",
    d: "M57.287,57.554h4.775a2.4,2.4,0,0,1-4.775,0Zm2.387-14.875a.63.63,0,0,1,.587.285l.466,1.062a.586.586,0,0,0,.354.32c2.11.636,3.343,2.026,3.343,3.862v3.026a4.028,4.028,0,0,0,1.718,3.451,1.252,1.252,0,0,1,.522,1.171c-.057.362-.2.559-.631.557H53.314c-.434,0-.574-.195-.631-.557a1.254,1.254,0,0,1,.52-1.171,4.023,4.023,0,0,0,1.722-3.451V48.207c0-1.836,1.229-3.226,3.339-3.862a.582.582,0,0,0,.36-.32l.46-1.062A.631.631,0,0,1,59.674,42.679Zm0-1.137a1.728,1.728,0,0,0-1.633.965l-.4.931c-2.255.807-3.851,2.523-3.851,4.77v3.026a2.639,2.639,0,0,1-1.261,2.537,2.38,2.38,0,0,0-.968,2.261,1.792,1.792,0,0,0,1.759,1.521h2.832a3.538,3.538,0,0,0,7.053,0h2.832a1.8,1.8,0,0,0,1.762-1.521,2.386,2.386,0,0,0-.968-2.261,2.636,2.636,0,0,1-1.266-2.537V48.208c0-2.247-1.589-3.962-3.844-4.77l-.411-.931A1.72,1.72,0,0,0,59.674,41.542Z",
    transform: "translate(-19.331 -12.771)",
    fill: "#135a7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1271",
    "data-name": "Path 1271",
    d: "M44.309,38.991h1.4a.8.8,0,0,1,.816.817v1.513a.8.8,0,0,1-.816.817h-1.4a.8.8,0,0,1-.817-.817V39.808A.8.8,0,0,1,44.309,38.991Zm0-1.142a1.967,1.967,0,0,0-1.956,1.959v1.513a1.966,1.966,0,0,0,1.956,1.958h1.4a1.964,1.964,0,0,0,1.953-1.958V39.808a1.964,1.964,0,0,0-1.953-1.959Z",
    transform: "translate(-15.184 -11.102)",
    fill: "#135a7f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1272",
    "data-name": "Path 1272",
    d: "M44.309,52.289h1.4a.8.8,0,0,1,.816.816v1.519a.8.8,0,0,1-.816.813h-1.4a.8.8,0,0,1-.817-.813V53.1A.8.8,0,0,1,44.309,52.289Zm0-1.137A1.961,1.961,0,0,0,42.353,53.1v1.519a1.961,1.961,0,0,0,1.956,1.953h1.4a1.959,1.959,0,0,0,1.953-1.953V53.1a1.959,1.959,0,0,0-1.953-1.953Z",
    transform: "translate(-15.184 -17.114)",
    fill: "#135a7f",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReminder);
export default __webpack_public_path__ + "static/media/reminder.6cd9732711bcb12d4e0816b32e98c8fa.svg";
export { ForwardRef as ReactComponent };